'use client'

import { Dialog, Navigation, Divider, Button, Cell, Text, Spacer } from '@vinted/web-ui'
import { X24 } from '@vinted/monochrome-icons'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

const RequestCarrierChangeConfirmationModal = ({ isOpen, onClose, onConfirm }: Props) => {
  const translate = useTranslate('conversation.request_carrier_change.confirmation_modal')

  return (
    <Dialog show={isOpen}>
      <Navigation
        body={translate('modal_title')}
        right={
          <Button
            styling="flat"
            onClick={onClose}
            iconName={X24}
            inline
            aria={{ 'aria-label': translate('actions.a11y.close') }}
            testId="request-carrier-change-confirmation-modal-close"
          />
        }
      />
      <Divider />
      <Cell>
        <Text as="h1" text={translate('title')} type="heading-xl" alignment="center" />
        <Spacer size="large" />
        <Text as="span" text={translate('body')} />
        <Spacer size="x-large" />
        <Button
          text={translate('actions.confirm')}
          styling="filled"
          onClick={onConfirm}
          testId="request-carrier-change-confirmation-modal-confirm"
        />
        <Spacer size="large" />
        <Button
          text={translate('actions.go_back')}
          styling="outlined"
          onClick={onClose}
          testId="request-carrier-change-confirmation-modal-go-back"
        />
      </Cell>
    </Dialog>
  )
}

export default RequestCarrierChangeConfirmationModal
